<div class="explanation" [ngClass]="{'explanation--has-link': link}">
  <div class="explanation__content" (click)="navigateToLink()" a11yKeyboardClickable>
    <vwui-icon class="explanation__icon explanation__icon--alert" iconName="alert"></vwui-icon>
    <ng-content></ng-content>
    @if (link) {
      <vwui-icon class="explanation__icon explanation__icon--next" iconName="next"></vwui-icon>
    }
  </div>
  <div class="explanation__actions" [ngClass]="{'explanation__actions--visible': actions.children.length > 0}" #actions><ng-content select="[actions]"></ng-content></div>
</div>
